import React from 'react';
import { GIButton, Modal } from 'app-components';
import styled from 'styled-components';

const StyledModalBody = styled.div`
    .gi-modal__content {
        width: 30% !important;
        padding-bottom: 0px;
    }
    .gi-modal__controls {
        text-align: left;
        button {
            display: inline-block;
        }
        .gi-button.gi-button__primary {
            float: right;
        }    
    }
`;

interface IUnsavedChangesDialogProps {
    message: string,
    headerId: string,
    onLeave: () => void,
    onStay: () => void,
}

const UnsavedChangesDialog = (props: IUnsavedChangesDialogProps) => {
    const { message, headerId, onLeave, onStay } = props;
    return (
        <StyledModalBody data-testid="unsaved-changes-modal-body">
            <Modal
                id={`unsaved-changes-${headerId}`}
                aria-labelledby={`unsaved-changes-title-${headerId}`}
                aria-describedby={`unsaved-changes-message-${headerId}`}
                data-testid={`unsaved-changes-modal-${headerId}`}
            >
                <Modal.Header
                    id={`unsaved-changes-title-${headerId}`}
                    titleId={headerId}
                    onHide={onLeave}
                    data-testid="unsaved-changes-modal-header"
                />
                <Modal.Body
                    id={`unsaved-changes-message-${headerId}`}
                    data-testid="unsaved-changes-modal-message"
                >
                    {message}
                </Modal.Body>
                <Modal.Controls data-testid="unsaved-changes-modal-controls">
                    <GIButton
                        id="btnUnsavedChangesStay"
                        variant="secondary"
                        labelId="common.label.stay"
                        onClickHandler={onStay}
                        aria-label="Stay on the current page"
                        data-testid="btn-unsaved-changes-stay"
                    />
                    <GIButton
                        id="btnUnsavedChangesLeave"
                        labelId="common.label.leave"
                        onClickHandler={onLeave}
                        aria-label="Leave the current page"
                        data-testid="btn-unsaved-changes-leave"
                    />
                </Modal.Controls>
            </Modal>
        </StyledModalBody>
    );
};

export default UnsavedChangesDialog;